module.exports = __webpack_public_path__ + "img/benin.e4149d7e.svg";